enum NumberOfColumns {
    One = 1,
    Two = 2
}

export default NumberOfColumns;